import { Table as TanStackTable } from "@tanstack/react-table";
import { FilterableFields, createContext } from "@utils";
import { TFunction } from "i18next";

export interface TableContextType<T = unknown> {
  tableId: string;
  t: TFunction<"translation", undefined>;
  table: TanStackTable<T>;
  sortableFields?: string[];
  filterableFields?: FilterableFields;
  baseFieldLabelTranslations?: string;
  editMode?: boolean;
  setEditMode?: (newEditMode: boolean) => void;
  columnWidths: Record<string, number>;
  onColumnResize: (columnId: string, width: number) => void;
}

const { Provider: TableContextProvider, useContext: useTableContext } =
  createContext<TableContextType>();

export { TableContextProvider, useTableContext };
